// extracted by mini-css-extract-plugin
export default {"hist":"hist--FoCLN"};